import { useRef } from "react";
import { getParsedNumber } from "../utils/Common";

function CustomInputNumber({
  name = "",
  placeholder,
  value,
  setValue,
  onPressEnter = () => {},
  shouldSetValueSetObj = false,
  inputClasses = "",
  isDecimalAllowed = false,
  disabled = false,
  highlight = false,
  max = 9999999999,
  min = -9999999999,
  addonBefore = "", // Only used for CustomInputV2. Not needed in other places
  addonAfter = "", // Only used for CustomInputV2. Not Needed in other places
  onFocus = () => {},
  onBlur = () => {}
}) {
  const inputRef = useRef(null);
  const lastValidValue = useRef(value || "");

  const inputCss = {
    borderColor: highlight ? "red" : "#D5D8DB",
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && typeof onPressEnter === "function") {
      onPressEnter();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow empty
    if (value === "") {
      lastValidValue.current = "";
      return shouldSetValueSetObj ? setValue({ name, value }) : setValue(value);
    }

    // Regex validation
    const pattern = isDecimalAllowed
      ? /^\d*\.?\d{0,2}$/ // whole + up to 2 decimal
      : /^\d+$/; // only whole numbers

    if (!pattern.test(value)) {
      e.target.value = lastValidValue.current;
      return;
    }

    // Min/Max validation
    const parsedNum = getParsedNumber(value);
    if (parsedNum > max || parsedNum < min) {
      e.target.value = lastValidValue.current;
      return;
    }

    lastValidValue.current = value;
    shouldSetValueSetObj && name ? setValue({ name, value }) : setValue(value);
  };

  const handlePaste = (e) => {
    const pasteText = e.clipboardData.getData("text");
    const pattern = isDecimalAllowed ? /^\d*\.?\d{0,2}$/ : /^\d+$/;

    if (!pattern.test(pasteText)) {
      e.preventDefault();
    }
  };

  return (
    <input
      ref={inputRef}
      type="text"
      name={name}
      disabled={disabled}
      onKeyDown={handleKeyDown}
      style={inputCss}
      value={value}
      placeholder={placeholder}
      className={`w-full rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px] ${
        addonBefore ? "rounded-r-md" : addonAfter ? "rounded-l-md" : "rounded-md"
      } ${inputClasses}`}
      onPaste={handlePaste}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
}

export default CustomInputNumber;
